import { useTranslation } from 'react-i18next';

function PitcherSeasonRecordComponent({record, leagueType}) {
    const { t } = useTranslation();
    let recordString = '';

    if (leagueType === 4201){
        recordString += (record['basicStat_gameCnt'] || 0);
        recordString += t('game') + " ";
        recordString += (record['win'] || 0);
        recordString += t('win') + " ";
        recordString += (record['lose'] || 0);
        recordString += t('lose') + " ";
        recordString += (record['save'] || 0);
        recordString += t('save') + " ";
        recordString += (record['hold'] || 0);
        recordString += t('hold');
    } else {
        recordString += (record['gameCnt'] || 0);
        recordString += t('game') + " ";
        recordString += (record['win'] || 0);
        recordString += t('win') + " ";
        recordString += (record['lose'] || 0);
        recordString += t('lose') + " ";
        recordString += (record['save'] || 0);
        recordString += t('save') + " ";
        recordString += (record['hold'] || 0);
        recordString += t('hold');
    }

    return (
        <>
            <div className="dataRow">
                {recordString}
            </div>
            <div className="dataTable">
                <table>
                    {
                    leagueType === 4201 ? 
                    <>
                    <thead>
                        <tr>
                            <th>{t('ip')}</th>
                            <th>ERA</th>
                            <th>FIP</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>{record['ip']}</td>
                            <td>{record['era']}</td>
                            <td>{record['fip']}</td>
                        </tr>
                        <tr>
                            <th>{t('so')}</th>
                            <th>{t('bb')}</th>
                            <th>WHIP</th>
                        </tr>
                        <tr>
                            <td>{record['basicStat_so']}</td>
                            <td>{record['basicStat_bb'] ? record['basicStat_bb']+record['basicStat_ibb'] : ''}</td>
                            <td>{record['whip']}</td>
                        </tr>
                    </tbody>
                    </>
                    :
                    <>
                    <thead>
                        <tr>
                            <th>{t('ip')}</th>
                            <th>ERA</th>
                            <th>승률</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>{record['ip']}</td>
                            <td>{record['era']}</td>
                            <td>{record['winRate']}</td>
                        </tr>
                        <tr>
                            <th>{t('so')}</th>
                            <th>{t('bb')}</th>
                            <th>WHIP</th>
                        </tr>
                        <tr>
                            <td>{record['so']}</td>
                            <td>{record['bb'] ? record['bb']*1+(record['ibb'] ? record['ibb']*1 : 0) : ''}</td>
                            <td>{record['whip']}</td>
                        </tr>
                    </tbody>
                    </>
                    }
                </table>
            </div>
        </>
    )
}

export default PitcherSeasonRecordComponent;